import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Button, {
      icon: "pi pi-print",
      class: "p-mr-1 tooltipButton formBox p-button-sm p-button-rounded notRequired",
      onClick: _ctx.printSpecimenLabel
    }, null, 8, ["onClick"])
  ])), [
    [
      _directive_tooltip,
      _ctx.$t('form.printSpecimenLabel'),
      void 0,
      { right: true }
    ]
  ])
}